import React from "react";
import {Navigate} from "react-router-dom";

const nextPage = "/height";

class Pregnancy extends React.Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.state = {
            redirect: false,
        }
    }
    nextPage () {
        this.setState({redirect: true,})
    }
    setPregnancy(e) {
        this.props.onDataChange(e, 'pregnancy');
        setTimeout(function() {this.nextPage()}.bind(this), 400);
    }
    componentDidMount() {
        if (this.props.gender === 'male') {
            this.props.onDataChange('No', 'pregnancy');
            this.setState({redirect: true,});
        }
        this.props.onDataChange('pregnancy', 'page');
    }

    render() {
        return (
            <div className={'text-center page pagePregnancy'}>
                <h1>Are you pregnant or breast feeding?</h1>
                <div className={'row'}>
                    <div className={'col'}>
                        <button type="button" className={'btn-choice btn-choice-big ' + (this.props.pregnancy === 'Yes'  ? 'active' : '')} onClick={() => this.setPregnancy('Yes')}>Yes</button>
                    </div>
                </div><br />
                <div className={'row'}>
                    <div className={'col'}>
                        <button type="button" className={'btn-choice btn-choice-big ' + (this.props.pregnancy === 'No'  ? 'active' : '')} onClick={() => this.setPregnancy('No')}>No</button>
                    </div>
                </div>
                {this.state.redirect && (
                    <Navigate to={nextPage} replace={true} />
                )}
            </div>
        )
    }
}

export default Pregnancy;
